import { produce } from 'immer';
import { DocUploadViewModel } from '../types/types';
import { logger } from '../utils/logger/logger';

import { MAX_DOC_UPLOAD_DOCS_ALLOWED } from '../../constants';

export const addFiles = (viewModel: DocUploadViewModel, files: File[]): DocUploadViewModel => {
    logger.info('addFiles() adding files', files);

    let nextState = viewModel;

    nextState = produce(nextState, (draft) => {
        Object
            .keys(nextState)
            .filter((key: string) => !!nextState[key] && key.includes('file'))
            .map((key: string) => nextState[key])
            .concat(files, Array(MAX_DOC_UPLOAD_DOCS_ALLOWED).fill(undefined))
            .splice(0, 3)
            .forEach((file: File, index: number) => draft[`file${index + 1}`] = file);
    });

    logger.info('returning', nextState);

    return nextState;
};

export const removeFile = (viewModel: DocUploadViewModel, fileNumber: number): DocUploadViewModel => {
    if (![1, 2, 3].includes(fileNumber)) {
        throw new Error(`Expected either 1, 2 or 3 for argument "fileNumber", but received ${fileNumber}`);
    }

    let viewModelClone;

    viewModelClone = produce(viewModel, (draft) => {
        Object
            .keys(viewModel)
            .filter((key: string) => !key.includes(fileNumber.toString()))
            .map((key: string) => viewModel[key])
            .concat(Array(MAX_DOC_UPLOAD_DOCS_ALLOWED).fill(undefined))
            .splice(0, 3)
            .forEach((file: File, index: number) => draft[`file${index + 1}`] = file);
    });

    return viewModelClone;

};

export const removeAllFiles = (viewModel: DocUploadViewModel): DocUploadViewModel => {

    let viewModelClone;

    viewModelClone = produce(viewModel, () => {
        return {};
    });

    return viewModelClone;

};
